<script setup lang="ts">
import { computed } from 'vue'
import OpensInNewTabIcon from '@/components/OpensInNewTabIcon.vue'
import { toolkitUrls } from '@/util/links.js'
import { getGoalSubjectLabelFromValue } from '@/contentprofile/no_sel_composable.js'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import { PRESENTLEVELS_EVENT_NAMES as EVENT_NAMES } from './event_names'

const props = defineProps({
  browseAssessmentSubject: { type: String, required: true },
})

const browseAssessmentsUrl = computed(() => {
  const baseUrl = `${toolkitUrls.browseAssessments}/?ref=presentlevels_side_panel`
  const params = new URLSearchParams()
  
  if (props.browseAssessmentSubject) {
    params.append('subject', getGoalSubjectLabelFromValue(props.browseAssessmentSubject))
  }
  
  const queryString = params.toString()
  return queryString ? `${baseUrl}&${queryString}` : baseUrl
})

const analytics = getAnalyticsTracker()

function handleBrowseAssessmentsClick() {
  analytics.sendEvent(EVENT_NAMES.ALIGNED_GOALS.BROWSE_ASSESSMENTS, {
    subject: props.browseAssessmentSubject,
  })
}
</script>

<template>
  <div class="browse-panel w-plw-subcontent-panel ml-4 mt-3 rounded-lg border bg-white shadow-[0_4px_6px_-4px_rgba(0,0,0,0.1),0_10px_15px_-3px_rgba(0,0,0,0.1)]">
    <div class="p-4">
      <h3 class="panel-heading font-medium text-md mb-2">Need more data sources?</h3>
      <a 
        :href="browseAssessmentsUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="browse-assessments-link flex items-center justify-center gap-2 px-8 py-2 bg-white rounded-[4px] transition-colors text-md font-medium w-full"
        @click="handleBrowseAssessmentsClick"
      >
        <OpensInNewTabIcon size="lg" class="flex items-center" />
        Browse {{ getGoalSubjectLabelFromValue(props.browseAssessmentSubject) }} Assessments
      </a>
    </div>
  </div>
</template>

<style scoped>
.browse-panel {
  border-color: #CCCCCC;
}

.panel-heading {
  color: #0A0A0A;
}

.browse-assessments-link {
  border: 1px solid #004D72;
  color: #004D72;
}

.browse-assessments-link:hover {
  background: #E6E6E6 !important;
  border: 1px solid #6F6F6F;
}

.browse-assessments-link:focus {
  outline: 2px solid #6F6F6F;
  border: 1px solid #6F6F6F;
  outline-offset: 2px;
  background: #E6E6E6 !important;
}
</style>
